<template>
    <div>
        <edit-base-dues-dialog
            v-model="show_dialog"
            :constants="constants"
            :baseDues="baseDuesValue"
            @successful-save="refreshData"
        />

        <internal-table-section
            section-title="Set Base Dues" button-text="Edit"
            @button-clicked="editBaseDues"
            class="tw-w-full"
            default_class="false"
        >
            <div class="tw-text-base tw-h-8 tw-p-2 tw-my-2 tw-text-black tw-flex tw-items-center" style="border-bottom: thin solid rgba(0, 0, 0, 0.12)" v-if="baseDuesValue">${{baseDuesValue}}</div>
        </internal-table-section>
    </div>
</template>

<script>
import InternalTableSection from "@/Generic/InternalTableSection";
import EditBaseDuesDialog from "@/Modals/EditBaseDuesDialog.vue";
export default {
    name: "WebsiteContentBaseDue",
    components: {
        InternalTableSection,
        EditBaseDuesDialog,
    },
    props: {
        'constants': {
            type: Object,
            required: false,
            default: function () {
                return undefined
            }
        },
        'baseDues': {
            type: String,
            required: false,
            default: function() {
                return ''
            }
        }

    },
    data() {
        return {
            show_dialog: false,
            baseDuesValue: this.baseDues || ''
        }
    },
    mounted() {
        //
    },
    computed: {

    },
    methods: {
        refreshData(data) {
            this.baseDuesValue = data
        },
        editBaseDues() {
            this.show_dialog = true
        },
    }
}
</script>
<style scoped>
.description {
    font-size: 0.9em;
}
</style>
